function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_6",
  fill: "none",
  d: "M0 0h26v26H0z",
  "data-name": "Path 6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_7",
  className: "icon-primary",
  d: "M13 2a11 11 0 1 0 11 11A11 11 0 0 0 13 2zM7.577 19.908c.473-.99 3.355-1.958 5.423-1.958s4.961.968 5.423 1.958a8.718 8.718 0 0 1-10.846 0zM20 18.313c-1.573-1.914-5.39-2.563-7-2.563s-5.423.649-7 2.563a8.8 8.8 0 1 1 13.992 0zM13 6.4a3.85 3.85 0 1 0 3.85 3.85A3.84 3.84 0 0 0 13 6.4zm0 5.5a1.65 1.65 0 1 1 1.65-1.65A1.648 1.648 0 0 1 13 11.9z",
  "data-name": "Path 7"
});

function SvgGenericUserProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "account_circle-24px",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericUserProfile);
export default __webpack_public_path__ + "static/media/generic-user-profile.4fecad97.svg";
export { ForwardRef as ReactComponent };